
namespace RioERP.Inventory {

    @Serenity.Decorators.registerClass()
    export class BookOutwardGrid extends Serenity.EntityGrid<BookOutwardRow, any> {
        protected getColumnsKey() { return BookOutwardColumns.columnsKey; }
        protected getDialogType() { return BookOutwardDialog; }
        protected getIdProperty() { return BookOutwardRow.idProperty; }
        protected getInsertPermission() { return BookOutwardRow.insertPermission; }
        protected getLocalTextPrefix() { return BookOutwardRow.localTextPrefix; }
        protected getService() { return BookOutwardService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}